/**
 *
 * @param inputBuffer    arraybuffer
 * @returns {Socket|string}  a hex string
 */
export function arrayBufferToHexString(inputBuffer) {
  let outputHexstr = inputBuffer
    .map(num => {
      let temp = num.toString(16);
      return temp.length === 1 ? "0" + temp : temp;
    })
    .join("");
  return outputHexstr;
}

/**
 *
 * @param groupInfo : a groupInfo object
 * @returns {string} groupName
 */
export function getGroupName(groupInfo, self, usersInfoMap) {
  if (groupInfo.groupName === "Group_Name_Default_String") {
    const userNames = getAllUserNameUnderGroup(groupInfo, usersInfoMap);
    if (userNames.length > 2) {
      return `${userNames.join().substr(0, 12)}...(${groupInfo.userCount})`;
    }
    for (let i = 0; i < userNames.length; i++) {
      if (userNames[i] !== self) {
        return userNames[i];
      }
    }
  }
  return groupInfo.groupName + ` (${groupInfo.userCount})`;
}

/**
 *
 * @param groupInfo {Object}
 * @returns {Array} userNames under a group
 */
export function getAllUserNameUnderGroup(groupInfo, usersInfoMap) {
  const userNames = [];
  console.log(">>>>>>>>>>>GroupInfo :", groupInfo);

  // if (groupInfo && groupInfo.senderMap) {
  //     Object.keys(groupInfo.senderMap).forEach((key) => {
  //         if (groupInfo.senderMap[key]) {
  //             userNames.push(groupInfo.senderMap[key].first_name);
  //         }
  //
  //     })
  // }
  if (groupInfo && groupInfo.senderUids) {
    const senderUids = groupInfo.senderUids;
    senderUids.forEach(senderUid => {
      if (usersInfoMap && usersInfoMap[`${senderUid}`]) {
        userNames.push(usersInfoMap[`${senderUid}`].first_name);
      }
    });
  }
  return userNames;
}

/**
 *
 * @param arrayBuffer {pure array}
 * @returns Node style buffer
 */
export function arrayBufferToNodeJsStyleBuffer(arrayBuffer) {
  let result = {};
  result.type = "Buffer";
  result.data = arrayBuffer;
  return result;
}

/**
 *
 * @param hexString {String}
 * @return {Node Style Array Buffer}
 */
export function hexStringToNodeJsStyleBuffer(hexString) {
  return arrayBufferToNodeJsStyleBuffer(hexStringtoArrayBuffer(hexString));
}

function hexStringtoArrayBuffer(hexString) {
  let buffer = [];
  let val = 0;
  let first = "";
  let second = "";
  for (let i = 0; i < hexString.length; i += 2) {
    val = 0;
    first = hexString.charAt(i);
    second = hexString.charAt(i + 1);
    if (
      first.charCodeAt(0) >= "a".charCodeAt(0) &&
      first.charCodeAt(0) <= "f".charCodeAt(0)
    ) {
      val += 16 * (first.charCodeAt(0) - "a".charCodeAt(0) + 10);
    } else {
      val += 16 * (first.charCodeAt(0) - "0".charCodeAt(0));
    }

    if (
      second.charCodeAt(0) >= "a".charCodeAt(0) &&
      second.charCodeAt(0) <= "f".charCodeAt(0)
    ) {
      val += second.charCodeAt(0) - "a".charCodeAt(0) + 10;
    } else {
      val += second.charCodeAt(0) - "0".charCodeAt(0);
    }

    buffer[i / 2] = val;
  }
  return buffer;
}

export function areNodeBufferEqual(a, b) {
  if (!a.data || !b.data) {
    return false;
  }
  for (let i = 0; i < a.data.length; i++) {
    if (a.data[i] !== b.data[i]) {
      return false;
    }
  }
  return true;
}

export function capitalizeFirstLetter(string) {
  if (string && string.length) {
    const res = string.charAt(0).toUpperCase() + string.slice(1);
    //console.log("String format", res);
    return res;
  }

  return "";
}

export function formatFloatNumber(number, digits) {
  return parseFloat(number.toFixed(digits));
}
export function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}
